<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container4">
<img alt="image" src="images/London_SouthSea-scan01.jpg"/>
<p class="center_t">“W<span class="small">HENEVER</span> I <span class="small">THINK OF MYSELF,</span> I <span class="small">SHALL THINK OF YOU.</span></p>
<p class="center">W<span class="small">HENEVEK MEN CALL ME BY NAME,</span> I <span class="small">SHALL THINK OF YOU.</span></p>
<p class="center">I<span class="small">S IT WELL, MASTEK?</span>”<a id="page_ii"></a></p><a id="page_ii">
</a></div><a id="page_ii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?12a9015a